import axios from 'axios'

const BASE_URL =
  import.meta.env.VITE_API_URL || 'https://module-manager.turbodevhub.com/api'

export function getFunnelsURL() {
  return (
    import.meta.env.VITE_FUNNELS_URL || 'https://staging-funnels.turbodebt.com'
  )
}

export interface PaginatedResponse<T> {
  data: T[]
  meta: {
    current_page: number
    last_page: number
    per_page: number
    total: number
  }
}

export interface ListParams {
  filters?: { key: string; value: string }[]
  include?: string
  orderBy?: string
  page?: number
  per_page?: number
  sort?: string
  sortedBy?: 'asc' | 'desc'
}

export function buildQuery(params?: ListParams): Record<string, unknown> {
  if (!params) return {}
  const query: Record<string, unknown> = {}

  if (params.filters) {
    for (const f of params.filters) {
      query[`filter[${f.key}]`] = f.value
    }
  }
  if (params.include) query.include = params.include
  if (params.orderBy) query.orderBy = params.orderBy
  if (params.page != null) query.page = params.page
  if (params.per_page != null) query.per_page = params.per_page
  if (params.sort) query.sort = params.sort
  if (params.sortedBy) query.sortedBy = params.sortedBy

  return query
}

export function createApi(prefix: string) {
  const instance = axios.create({
    baseURL: `${BASE_URL}${prefix}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('td-credential')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  })

  return instance
}
